export default __webpack_public_path__ + "static/media/sun-logo-black.8afbdb23.png";